<template>
    <Title>Public Site</Title>
    <main class="flex flex-col h-screen">
        <Header></Header>
        <div class="px-6 flex-1 py-12">
            <section class="w-full max-w-5xl mx-auto">
                <slot></slot>
            </section>
        </div>
        <Footer></Footer>
    </main>
</template>


<script setup>
import Footer from "~/components/public/Footer.vue";
import Header from "~/components/public/Header.vue";
const { theme } = useTheme();

useHead({
    bodyAttrs: {
        class: 'overscroll-y-none'
    },
    style: [{
        innerHTML: `
            :root {
                --theme-link-color: ${theme.value.linkText};
                --theme-link-hover-color: ${theme.value.linkHover};
            }
            a {
                color: var(--theme-link-color);
                transition: color 0.15s ease;
            }
            a:hover {
                color: var(--theme-link-hover-color);
            }
        `
    }]
});

</script>
